import React, { useState, useEffect } from "react";
import { FaFacebook } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaInstagramSquare } from "react-icons/fa";
import shopController from "../../../node_modules/shops-query/src/modules/shop/index";
import footerLogo from "../../assets/footer logo1.png";
import { shopid } from "../../utils/url";
import { Link, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/Auth";

const Footer = () => {
  const [shop, setShop] = useState(null);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  const handleLogoClick = () => {
    window.location.reload();
  };

  useEffect(() => {
    const loadShop = async () => {
      try {
        const data = await shopController.fetchShops({ id: shopid });
        setShop(data?.[0]);
      } catch (err) {
        console.error("Failed to load shop:", err);
      }
    };

    const loadUser = () => {
      try {
        const user = getUserData();
        setUserData(user);
      } catch (err) {
        console.error("Failed to load user:", err);
      }
    };

    loadShop();
    loadUser();
  }, []);

  const policyLinks = [
    { label: "Shipping & Return Policy", path: "/shipping_return_policy" },
    { label: "Terms & Conditions", path: "/terms_conditions" },
    { label: "Cancellation Policy", path: "/cancellation_policy" },
    { label: "Track Your Order", path: "/track_order" },
    { label: "Return Policy", path: "/return_policy" },
    { label: "Privacy Policy", path: "/privacy_policy" },
  ];

  const handlePolicyClick = (path) => {
    navigate(path, { state: { cms: shop?.CMS || {} } });
  };

  // Function to format phone number for tel: link
  const formatPhoneForDial = (phone) => {
    if (!phone) return "tel:+917777777777";

    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');

    // If phone starts with 91, add + prefix
    if (digits.startsWith('91')) {
      return `tel:+${digits}`;
    }

    // If phone starts with +, use as is
    if (phone.startsWith('+')) {
      return `tel:${phone}`;
    }

    // Default: assume Indian number and add +91
    return `tel:+91${digits}`;
  };

  return (
    <div className="bg-black text-white font-poppins  md:h-[340px] overflow-hidden">
      {/* Desktop Footer */}
      <div className="hidden md:block">
        <div className="max-w-8xl px-16 mx-auto flex flex-col md:flex-row justify-between gap-10 py-10 ">
          {/* Logo */}
          <div onClick={handleLogoClick} className="cursor-pointer">
            <img src={footerLogo} alt="Logo" className="mt-5" />
          </div>

          {/* Links */}
          <div className="flex flex-col sm:flex-row gap-28 font-poppins">
            {/* Quick Links */}
            <div>
              <h4 className="font-semibold mb-4 text-[18px]">Quick Links</h4>
              <ul className="space-y-1 opacity-80 text-[12px]">
                {/* <li>
                  <Link to="/coming-soon" className="hover:underline">
                    Our Story
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/all-products?sort=new_arrivals"
                    className="hover:underline"
                  >
                    New Arrivals
                  </Link>
                </li>
                <li>
                  <Link to="/all-products" className="hover:underline">
                    All products
                  </Link>
                </li>
              </ul>
            </div>

            {/* Help & Support */}
            <div className="-mr-10">
              <h4 className="font-semibold mb-4 text-[18px]">Help & Support</h4>
              <ul className="space-y-1 opacity-80 text-[12px]">
                {policyLinks.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handlePolicyClick(item.path)}
                    className="hover:underline cursor-pointer"
                  >
                    {item.label}
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Us */}
            <div>
              <h4 className="font-semibold mb-4 text-[18px]">Contact Us</h4>
              <div className="opacity-80 text-sm">
                <p className="text-[12px]">Call us at</p>
                <p className="text-[12px]">
                  <a
                    href={formatPhoneForDial(shop?.phone)}
                    className="hover:underline"
                  >
                    {shop?.phone}
                  </a>
                </p>

                <p className="mt-2 text-[12px]">Mail to</p>
                <p className="text-[12px]">
                  <a
                    href={`mailto:${shop?.email || "boo@gmail.com"}`}
                    className="hover:underline"
                  >
                    {shop?.email || "boo@gmail.com"}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-white text-xl m-0"> Version: 1.2.0 </p>
        </div>

        {/* Bottom Bar */}
        <div className="max-w-8xl mx-auto px-6 flex flex-col sm:flex-row justify-between items-center border-t border-[#555555] pt-2">
          <p className="text-xs opacity-80 ml-[40px] my-2 mt-4">
            &copy; 2025 Boo ecommerce. All rights reserved.
          </p>

          <div className="flex gap-6 mr-10 sm:mt-0">
            <a
              href="https://www.facebook.com/"
              className="text-xl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/"
              className="text-xl"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AiFillInstagram size={24} />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile Footer */}
      <div className="block md:hidden text-center py-10">
        <img src={footerLogo} alt="Logo" className="mx-auto mb-6 w-20" />

        <div className="flex justify-center text-start gap-16 mb-8">
          <div>
            <h4 className="font-semibold mb-2">Quick Links</h4>
            <ul className="text-sm opacity-80 space-y-1">
              {/* <li>
                  <Link to="/coming-soon" className="hover:underline">
                    Our Story
                  </Link>
                </li> */}
              <li>
                <Link
                  to="/all-products?sort=new_arrivals"
                  className="hover:underline"
                >
                  New Arrivals
                </Link>
              </li>
              <li>
                <Link to="/all-products" className="hover:underline">
                  All products
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-2">Help & Support</h4>
            <ul className="text-sm opacity-80 space-y-1">
              {policyLinks.map((item, index) => (
                <li
                  key={index}
                  onClick={() => handlePolicyClick(item.path)}
                  className="hover:underline cursor-pointer"
                >
                  {item.label}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <hr className="border-[#555] mx-8 mb-6" />

        <div className="mb-4">
          <h4 className="font-semibold mb-2">Contact Us</h4>
          <p className="text-sm opacity-80">
            Call us at:{" "}
            <a
              href={formatPhoneForDial(shop?.phone)}
              className="hover:underline"
            >
              {shop?.phone}
            </a>
          </p>
          <p className="text-sm opacity-80">
            Mail to:{" "}
            <a
              href={`mailto:${shop?.email || "boo@gmail.com"}`}
              className="hover:underline"
            >
              {shop?.email || "boo@gmail.com"}
            </a>
          </p>
        </div>

        <hr className="border-[#555]" />

        <p className="text-white"> Version:1.2.1 </p>

        <p className="text-xs opacity-80 mb-4">
          © 2025 Boo ecommerce. All rights reserved.
        </p>

        <div className="flex justify-center gap-8">
          <a
            href="https://www.facebook.com/"
            className="text-xl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook />
          </a>
          <a
            href="https://www.instagram.com/"
            className="text-xl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiFillInstagram size={24} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
